































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Base } from '@/components/common/base';
import VueApexCharts from 'vue-apexcharts';

@Component({
  props: [
    'methodName',
    'progress',
    'title',
    'chartOptions',
    'series',
    'updateFilterDate',
    'updateChartType',
    'selectedDate',
    'count',
    'chartType',
  ],
  components: {
    apexchart: VueApexCharts,
  },
})
export default class ChartBarPage extends Base {
  public chartSelectedDate = '';
  public graphType = 'bar';
  public chartHeight = '';
  public totalCount = 0;
  public sizes = ['24 hours', '07 days', '15 days'];
  public switchText = '';

  public switchVal: boolean = false;

  public onChangeChartType(value, title) {
    this.switchVal = value;
    if (value) {
      value = 'line' + ',' + title;
      this.$emit('updateChartType', value);
    } else {
      value = 'bar' + ',' + title;
      this.$emit('updateChartType', value);
    }
  }

  public seriesData = [];
  public chartOption = {};

  public updateDate(value, title) {
    value = value + ',' + title;
    this.$emit('updateFilterDate', value);
  }

  public async mounted() {
    this.seriesData = this.$props.series;
    this.chartOption = this.$props.chartOptions;
    this.chartSelectedDate = this.$props.selectedDate;
    this.totalCount = this.$props.count;
    this.graphType = this.$props.chartType;
    this.switchVal = this.$props.chartType == 'bar' ? false : true;
    this.switchText = 'Line Chart';
    this.chartHeight = this.$props.title == 'Payments' ? '500' : '250';
  }
}
